const moneyFormats = new Map<string, Intl.NumberFormat>();

/** Decimal string from the API in the user's locale: "7309.49" → "7 309,49 ₽". */
export function formatMoney(amount: string, currency = 'RUB'): string {
  let format = moneyFormats.get(currency);
  if (!format) {
    format = new Intl.NumberFormat('ru-RU', { style: 'currency', currency });
    moneyFormats.set(currency, format);
  }
  const value = Number(amount);
  return Number.isFinite(value) ? format.format(value) : amount;
}

export function formatNumber(value: string): string {
  const number = Number(value);
  return Number.isFinite(number)
    ? number.toLocaleString('ru-RU', { maximumFractionDigits: 3 })
    : value;
}

const dateTime = new Intl.DateTimeFormat('ru-RU', { dateStyle: 'medium', timeStyle: 'short' });
const date = new Intl.DateTimeFormat('ru-RU', { dateStyle: 'medium' });

export function formatDateTime(iso: string | null): string {
  return iso ? dateTime.format(new Date(iso)) : '—';
}

export function formatDate(iso: string | null): string {
  return iso ? date.format(new Date(iso)) : '—';
}

/** ``<input type="datetime-local">`` value (local time, no zone) into ISO with the offset. */
export function localInputToIso(value: string): string {
  const moment = new Date(value);
  const offset = -moment.getTimezoneOffset();
  const sign = offset >= 0 ? '+' : '-';
  const pad = (part: number) => String(Math.trunc(Math.abs(part))).padStart(2, '0');
  return `${value.length === 16 ? `${value}:00` : value}${sign}${pad(offset / 60)}:${pad(offset % 60)}`;
}

export function isoToLocalInput(moment: Date): string {
  const pad = (part: number) => String(part).padStart(2, '0');
  return `${moment.getFullYear()}-${pad(moment.getMonth() + 1)}-${pad(moment.getDate())}T${pad(moment.getHours())}:${pad(moment.getMinutes())}`;
}
